import { Model } from '@vuex-orm/core';
import Address from './Address';
import Equipment from './Equipment';

export default class Position extends Model {
    static entity = 'positions';

    static fields() {
        return {
            id: this.increment(),
            transaction_id: this.number(null).nullable(),
            amount: this.number(null).nullable(),
            wantsFillOption: this.boolean(false),
            warenempfaenger_id: this.number(null).nullable(),
            regulierer_id: this.number(null).nullable(),
            equipment_id: this.number(null).nullable(),

            //relations
            warenempfaenger: this.belongsTo(Address, 'warenempfaenger_id'),
            regulierer: this.belongsTo(Address, 'regulierer_id'),
            equipment: this.belongsTo(Equipment, 'equipment_id')
        }
    }
}